import { CreateMarketplaceRequest } from 'APIs/marketplaces/marketplaces.types';

export type CreateMarketplaceFormProps = {
  enterpriseId?: { value: string; label: string };
  slug: string;
  businessName: string;
  website: string;
  companyEmail: string;
  companyPhone: string;
  zendeskUserGroupId?: number;
  enableMerchantDashboardAccess: boolean;
  shortenerBaseUri?: string;
  enableMarketplaceCustomerUsers?: boolean;
};

type ToCreateMarketplaceRequest = (createMarketplaceForm: CreateMarketplaceFormProps) => CreateMarketplaceRequest;

export const toCreateMarketplaceRequest: ToCreateMarketplaceRequest = (
  createMarketplaceForm: CreateMarketplaceFormProps,
): CreateMarketplaceRequest => {
  return {
    enterpriseId: createMarketplaceForm.enterpriseId?.value || '',
    slug: createMarketplaceForm.slug,
    businessName: createMarketplaceForm.businessName,
    website: createMarketplaceForm.website,
    companyEmail: createMarketplaceForm.companyEmail,
    companyPhone: createMarketplaceForm.companyPhone,
    zendeskUserGroupId: createMarketplaceForm.zendeskUserGroupId,
    enableMerchantDashboardAccess: createMarketplaceForm.enableMerchantDashboardAccess,
    shortenerBaseUri: createMarketplaceForm.shortenerBaseUri,
    enableMarketplaceCustomerUsers: createMarketplaceForm.enableMarketplaceCustomerUsers,
  };
};
